
/**
 * Utility functions for authentication
 */

/**
 * Clean up authentication state from local storage and session storage
 */
export const cleanupAuthState = () => {
  // Remove standard auth tokens
  localStorage.removeItem('supabase.auth.token');
  
  // Remove all Supabase auth keys from localStorage
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('supabase.auth.') || key.includes('sb-')) {
      localStorage.removeItem(key);
    }
  });
  
  // Remove from sessionStorage if in use
  Object.keys(sessionStorage || {}).forEach((key) => {
    if (key.startsWith('supabase.auth.') || key.includes('sb-')) {
      sessionStorage.removeItem(key);
    }
  });
};

/**
 * Format a user's name for display
 * @param user Supabase user object
 * @returns formatted display name
 */
export const getDisplayName = (user: any): string => {
  if (!user) return "";
  
  const userMetadata = user.user_metadata;
  if (userMetadata && userMetadata.full_name) {
    return userMetadata.full_name;
  }
  
  return user.email ? user.email.split('@')[0] : "User";
};

